export { default } from "./HomeClaimHeader";
